import { useState } from "react";
import { ChevronDown, ChevronRight, AlertCircle } from "lucide-react";

export default function UnmatchedPanel({ items }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50/60 mt-6" data-testid="unmatched-panel">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-5 py-4 text-left"
        data-testid="unmatched-toggle"
      >
        <div className="flex items-center gap-3 text-slate-600">
          {open ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
          <AlertCircle className="w-4 h-4 text-slate-400" />
          <div>
            <div className="text-sm font-semibold">
              Unmatched Sign-Ins <span className="tabular-nums">({items.length})</span>
            </div>
            <div className="text-xs text-slate-500">Visitors or staff not on the Approved List — diagnostic only</div>
          </div>
        </div>
      </button>
      {open && (
        <div className="border-t border-slate-200 overflow-x-auto">
          {items.length === 0 ? (
            <div className="px-5 py-6 text-center text-sm text-slate-500" data-testid="unmatched-empty">
              No unmatched sign-ins. All visits matched the staff roster.
            </div>
          ) : (
            <table className="w-full text-sm">
              <thead className="bg-slate-100 text-slate-500">
                <tr>
                  <th className="text-left px-4 py-2 text-[11px] uppercase tracking-[0.16em]">Name</th>
                  <th className="text-left px-4 py-2 text-[11px] uppercase tracking-[0.16em]">Email</th>
                  <th className="text-left px-4 py-2 text-[11px] uppercase tracking-[0.16em]">Sign-In</th>
                  <th className="text-left px-4 py-2 text-[11px] uppercase tracking-[0.16em]">Visit Type</th>
                  <th className="text-left px-4 py-2 text-[11px] uppercase tracking-[0.16em]">Device</th>
                </tr>
              </thead>
              <tbody>
                {items.map((u) => (
                  <tr key={u.visit_id} className="border-t border-slate-200">
                    <td className="px-4 py-2 font-medium text-slate-700">{u.guest_full_name || "—"}</td>
                    <td className="px-4 py-2 text-slate-600">{u.guest_email || "—"}</td>
                    <td className="px-4 py-2 tabular-nums text-slate-600">{u.check_in_local_display || "—"}</td>
                    <td className="px-4 py-2 text-slate-600">{u.visit_type || "—"}</td>
                    <td className="px-4 py-2 text-slate-600">{u.device_name || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
